import { Injectable, EventEmitter } from '@angular/core';
import {
  AsyncValidatorFn,
  AbstractControl,
  ValidationErrors,
} from '@angular/forms';
import {
  BaseFpxDataService,
  CreateFn,
  FindAllFn,
  FindByKeyFn,
  HttpRequest,
  LookUpFn,
  ModifyFn,
  //PatchFn,
  CriteriaQuery,
  HttpProviderService,
  ILookUpData,
  FpxIHttpOption
} from '@fpx/core';
import { IHttpSuccessPayload, ILookupResponse } from '@fpx/core';
import { add } from '@amcharts/amcharts4/.internal/core/utils/Array';
import { map, Observable, of, catchError } from 'rxjs';
import { Supplapplicant, SupplapplicantMaintanence } from './supplapplicant.model';
import { Supplcardreq } from '../supplcardreq-service/supplcardreq.model';
import { environment } from 'src/environments/environment';
@Injectable(
  {providedIn:'root'}
)
export class SupplapplicantService implements BaseFpxDataService<any> {
  constructor(private _httpProvider: HttpProviderService) { }
  create(payload: Supplapplicant, httpOption: Map<keyof FpxIHttpOption, Map<string, any>> = new Map()): CreateFn<any> {
    return () => {
      const httpRequest = new HttpRequest();
      httpRequest.setMethod('POST');
      httpRequest.setResource('/supplapplicant');
      let bodyContent = { "supplapplicant": payload };
      httpRequest.setBody(bodyContent);
      httpRequest.setServerContext(environment.customersPublisher);
      return this._httpProvider.invokeRestApi(httpRequest, httpOption);
    };
  }

  findByKey(key: any, httpOption: Map<keyof FpxIHttpOption, Map<string, any>> = new Map()): FindByKeyFn<any> {
    return () => {
      const httpRequest = new HttpRequest();
      httpRequest.setResource('/supplapplicant/{appRef}');
      httpRequest.addPathParameter('appRef', key.appRef);
      httpRequest.setMethod('GET');
      httpRequest.setServerContext(environment.customersPublisher);

      return this._httpProvider
        .invokeRestApi(httpRequest, httpOption)
        .pipe(map((res: IHttpSuccessPayload<any>) => res.body?.supplapplicant ?? null), map((res: any) => {
          return res ? { ...res, idType: res.idType?.code || res.idType, applicationtype: res.applicationtype?.applicationtype || res.applicationtype, source: res.source?.code || res.source } : null
        }), catchError((err: any) => {
          return of(null)
        }));

    };
  }

  modify(payload: Supplapplicant, httpOption: Map<keyof FpxIHttpOption, Map<string, any>> = new Map()): ModifyFn<any> {
    return () => {
      const httpRequest = new HttpRequest();
      httpRequest.setResource('/supplapplicant/{appRef}');
      httpRequest.addPathParameter('appRef', payload.appRef);
      httpRequest.setMethod('PUT');
      let bodyContent = { "supplapplicant": payload };
      httpRequest.setBody(bodyContent);
      httpRequest.setServerContext(environment.customersPublisher);
      return this._httpProvider.invokeRestApi(httpRequest, httpOption);
    };
  }

  //  patch(payload: Supplapplicant,httpOption: Map<keyof FpxIHttpOption, Map<string, any>> = new Map()): PatchFn<any> {
  //   return () => {
  //     const httpRequest = new HttpRequest();
  //     httpRequest.setResource('/supplapplicant/{appRef}');
  //      httpRequest.addPathParameter('appRef', payload.appRef);
  //    httpRequest.setMethod('PUT');
  //     let bodyContent = {"supplapplicant":payload};
  //     httpRequest.setBody(bodyContent);
  //     return this._httpProvider.invokeRestApi(httpRequest,httpOption);
  //   };
  // }

  findAll(criteriaQuery: CriteriaQuery, httpOption: Map<keyof FpxIHttpOption, Map<string, any>> = new Map()): FindAllFn<SupplapplicantMaintanence> {
    return () => {
      const httpRequest = new HttpRequest();
      httpRequest.setResource('/supplapplicant');
      httpRequest.setMethod('GET');
      httpRequest.setCriteriaQuery(criteriaQuery);
      return this._httpProvider
        .invokeRestApi(httpRequest, httpOption)
        .pipe(
          map(
            (res: IHttpSuccessPayload<SupplapplicantMaintanence>) => {
              return {
                data: res.body?.supplapplicant || [],
                totalRowCount: res.body?.totalRowCount
              }
            }
          )
        );
    };
  }


  lookup(key: any, httpOption: Map<keyof FpxIHttpOption, Map<string, any>> = new Map()): LookUpFn<any> {
    return () => {
      const httpRequest = new HttpRequest();
      httpRequest.setMethod('GET');
      httpRequest.setResource('/supplapplicant');
      httpRequest.addQueryParameter('lookup', 1);
      const httpCriteria = new CriteriaQuery();
      httpCriteria.setPaginationCriteria('1', 10);
      httpCriteria.addFilterCritertia('text', 'String', 'startsWith', {
        searchText: key.searchText ?? '',
      });
      httpRequest.setCriteriaQuery(httpCriteria);

      return this._httpProvider.invokeRestApi(httpRequest, httpOption).pipe(
        map((res: IHttpSuccessPayload<ILookupResponse>) => {
          return res.body?.Data;
        })
      );
    };
  }

  loadSummary(criteriaQuery: CriteriaQuery, httpOption: Map<keyof FpxIHttpOption, Map<string, any>> = new Map()): FindAllFn<any> {
    return () => {
      const httpRequest = new HttpRequest();
      httpRequest.setResource("/supplapplicant/stats");
      httpRequest.setMethod("GET");
      httpRequest.setCriteriaQuery(criteriaQuery);
      return this._httpProvider
        .invokeRestApi(httpRequest, httpOption)
        .pipe(map((res: IHttpSuccessPayload<any>) => res.body));
    };
  }

  fetchPrimCardHolderDtls(key: any): Observable<Supplcardreq> {
    const httpRequest = new HttpRequest();
    httpRequest.setResource('/supplcardreq/{inventoryNumber}');
    httpRequest.addPathParameter('inventoryNumber', key.inventoryNumber);
    httpRequest.setMethod('GET');
    httpRequest.setServerContext(environment.customersPublisher);
    return this._httpProvider
      .invokeRestApi(httpRequest)
      .pipe(map(
        (res: IHttpSuccessPayload<any>) => {
          return res.body?.supplcardreq
        }), catchError((err: any) => {
        return of(null)
      }));
  }

  fetchApplicantInfo(key: any): Observable<any> {
    const httpRequest = new HttpRequest();
    httpRequest.setResource('/supplapplicant/{appRef}');
    httpRequest.addPathParameter('appRef', key.appRef);
    httpRequest.setMethod('GET');
    httpRequest.setServerContext(environment.customersPublisher);
    return this._httpProvider
      .invokeRestApi(httpRequest)
      .pipe(map((res: IHttpSuccessPayload<any>) => res.body?.supplapplicant ?? null), map((res: any) => {
        return res ? { ...res } : null
      }), catchError((err: any) => {
        return of(null)
      }));
  }

}
